import { pulseSpin, rectSpin, planeSpin, cubeSpin, preloaderSpin, chaseSpin } from './spin';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '正在加载中...'
    },
    textColor: {
      type: String,
      default: '#3ff9dc'
    },
    background: {
      type: String,
      default: 'rgba(0,0,0,0.7)'
    },
    spin: {
      type: String,
      default: 'loading'
    }
  },
  components: {
    pulseSpin,
    rectSpin,
    planeSpin,
    cubeSpin,
    preloaderSpin,
    chaseSpin
  }
};